import { API, authClient } from "../index";

export const postProductUnitType = async (productUnitType, accessToken) => {
	return authClient(accessToken).post(
		`${API}/product-unit-types`,
		productUnitType
	);
};

export const getProductUnitTypes = (accessToken) => {
	return authClient(accessToken).get(`${API}/product-unit-types`);
};

export const getProductUnitTypeById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/product-unit-types/${id}`);
};

export const updateProductUnitType = async (
	id,
	productUnitType,
	accessToken
) => {
	return authClient(accessToken).put(
		`${API}/product-unit-types/${id}`,
		productUnitType
	);
};

export const deleteProductUnitType = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/product-unit-types/${id}`);
};
